import { useState } from 'react';
import { Link } from 'react-router-dom';

import { ArrowDownIcon, ArrowFullRightIcon, DamageMissingTrimIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { useVehicle } from '@motorway/motorway-handshake-components';
import { MessagingCard } from '@motorway/motorway-handshake-components';

import { DetailsModal } from '../../components/DetailsModal/DetailsModal';
import { DamageWrapper } from '../../components/PopOvers/DamageWrapper';
import { ROUTES } from '../../helpers/routes';
import { NumericGradingText } from '../NumericGradingText/NumericGradingText';
import { VehicleCard } from '../VehicleCard/VehicleCard';

import type { SnowplowPayload } from '../../helpers/snowplow';

import styles from './VehicleSummary.module.scss';

interface VehicleSummaryProps {
  clickCallback?: (payload: SnowplowPayload) => void;
}

export const VehicleSummary = ({ clickCallback = () => void 0 }: VehicleSummaryProps) => {
  const [openModal, setOpenModal] = useState(false);

  const { vehicle: { enquiry } } = useVehicle();
  const { numericGrade, lastMOTPass, serviceHistory } = enquiry?.vehicleDetails ?? {};

  const FULL_OR_PARTIAL_SERVICE_HISTORY = ['full', 'partial'].includes(serviceHistory ?? '');

  const displayPips = numericGrade ?? lastMOTPass ?? FULL_OR_PARTIAL_SERVICE_HISTORY;

  const snowplowProfileData = {
    name: 'vehicle_profile_clicked',
    url: ROUTES.PROFILE,
  };

  const snowplowDamageData = {
    name: 'declared_damage_clicked',
  };

  return (
    <>
      <div className={styles.component}>
        <MessagingCard
          className={styles.vehicleProfile}
          action={(
            <>
              <VehicleCard padding={false} />
              {
                displayPips && (
                  <ul className={styles.vehiclePips}>
                    {numericGrade && <li className={styles.grade}><NumericGradingText grade={numericGrade} size="regular" /></li>}
                    {FULL_OR_PARTIAL_SERVICE_HISTORY && (
                      <li>
                        {serviceHistory}
                        {' '}
                        Service
                      </li>
                    )}
                    {lastMOTPass && <li>MOT</li>}
                  </ul>
                )
              }
              <div
                data-handshake-popover
                className={styles.declaredDamage}
                onClick={() => {
                  setOpenModal(true);
                  clickCallback(snowplowDamageData);
                }}
              >
                <span>
                  <DamageMissingTrimIcon />
                  Declared damage
                </span>
                <ArrowDownIcon />
              </div>
            </>
          )}
          heading={(
            <Hyperlink
              as={Link}
              data-thc-style-override
              inherit={true}
              label={(
                <>
                  <span>View vehicle profile</span>
                  <ArrowFullRightIcon />
                </>
              )}
              onClick={() => { clickCallback(snowplowProfileData); }}
              to={ROUTES.PROFILE}
              underline={false}
            />
          )}
        />
      </div>
      {
        openModal && (
          <DetailsModal onCloseModalClick={() => { setOpenModal(false); }}>
            <DamageWrapper />
          </DetailsModal>
        )
      }
    </>
  );
};
